export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13898.cca9a9d7.jpg";